
import { Box, TextField, Typography } from "@mui/material";

import { SalesAidsStyles } from "./SalesAidsStyles";
const ServiceMaintenance = ({ artifacts, setArtifacts, handleArrowClick, isFollowupEnabled }) =>  {
  const handleTextChange = (field, value) => {
    setArtifacts((prev) => ({
      ...prev,
      service_maintenance: {
        ...prev.service_maintenance,
        [field]: value,
        isEdit: true,
      },
    }));
  };



  return (
    <Box
      sx={{
        ...SalesAidsStyles.outerBox,
        gap: 2,
        p: "6px",
        bgcolor: artifacts?.isEdit ? "#FFF7F7" : null,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          width: "100%",
        }}
      >
        {/* Satisfaction Message Row */}

        <Box sx={{ display: "flex", gap: 2 }}>
          <Box sx={{ flex: 1 }}>
            <Typography sx={SalesAidsStyles.wordStyle}>English</Typography>
            <TextField
              fullWidth
              variant="outlined"
              label="Follow-up Message 1"
              onChange={(e) =>
                handleTextChange("followup_message_1", e.target.value)
              }
              sx={{ mt: 2 }}
              value={artifacts?.followup_message_1 || ""}
              multiline
              disabled={!isFollowupEnabled}
            />
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography sx={SalesAidsStyles.wordStyle}>Spanish</Typography>
            <TextField
              fullWidth
              variant="outlined"
              label="Mensaje de seguimiento"
              onChange={(e) =>
                handleTextChange("es_followup_message_1", e.target.value)
              }
              sx={{ mt: 2 }}
              value={artifacts?.es_followup_message_1 || ""}
              multiline
              disabled={!isFollowupEnabled}
            />
          </Box>
        </Box>
        <Box sx={{ display: "flex", gap: 2 }}>
          <TextField
            fullWidth
            variant="outlined"
            label="Follow-up Message 2"
            onChange={(e) =>
              handleTextChange("followup_message_2", e.target.value)
            }
           
            value={artifacts?.followup_message_2 || ""}
            multiline
            disabled={!isFollowupEnabled}
          />

          <TextField
            fullWidth
            variant="outlined"
            label="Mensaje de seguimiento"
            onChange={(e) =>
              handleTextChange("es_followup_message_2", e.target.value)
            }
           
            value={artifacts?.es_followup_message_2 || ""}
            multiline
            disabled={!isFollowupEnabled}
          />
        </Box>
        <Box sx={{ display: "flex", gap: 2 }}>
          <TextField
            fullWidth
            variant="outlined"
            label="Follow-up Message 3"
            onChange={(e) =>
              handleTextChange("followup_message_3", e.target.value)
            }
         
            value={artifacts?.followup_message_3 || ""}
            multiline
            disabled={!isFollowupEnabled}
          />

          <TextField
            fullWidth
            variant="outlined"
            label="Mensaje de seguimiento"
            onChange={(e) =>
              handleTextChange("es_followup_message_3", e.target.value)
            }
         
            value={artifacts?.es_followup_message_3 || ""}
            multiline
            disabled={!isFollowupEnabled}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default ServiceMaintenance;
